import { ErrorSummary } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type Result = {
  field: string;
  message: string | undefined;
  type: string | undefined;
  fieldId: string | undefined;
}[];

const findErrorsRecursively = (obj: Record<string, any>, result: Result = []) => {
  for (const key in obj) {
    const value = obj?.[key];

    if (typeof value !== 'object') {
      return result;
    }

    if (typeof value === 'object' && (value?.type || value?.message)) {
      result.push({ field: key, message: value?.message, type: value?.type, fieldId: value?.ref.id });
    } else {
      // Continue recursively for nested objects
      findErrorsRecursively(value, result);
    }
  }

  return result;
};

interface Props {
  errors: Record<string, any>;
}

// Common form error component to handle React Hook Form errors
export const FormErrors: FC<Props> = ({ errors }) => {
  const { t } = useTranslation();

  if (Object.keys(errors).length === 0) {
    return null;
  }

  // Merge object errors and array errors into a single array
  const mergedErrors = findErrorsRecursively(errors);

  return (
    <ErrorSummary>
      <ErrorSummary.Heading>{t('register.solar.form.errors.header')}</ErrorSummary.Heading>
      <ErrorSummary.List>
        {
          //Iterate through errors and display them
          mergedErrors.map((item, index) => (
            <ErrorSummary.Item key={`${item.field}-${index}`}>
              <ErrorSummary.Link href={`#${item.fieldId}`}>{item.message}</ErrorSummary.Link>
            </ErrorSummary.Item>
          ))
        }
      </ErrorSummary.List>
    </ErrorSummary>
  );
};
